export const commonMessage = {
  videoDeviceNotAvailable:
    "The camera you selected is not available. It may be used by another application. Please select a different camera.",
  audioDeviceNotAvailable:
    "The microphone you selected is not available. Please select the different microphone",
};
